import { render, staticRenderFns } from "./InterviewCreate.vue?vue&type=template&id=99fc565a"
import script from "./InterviewCreate.vue?vue&type=script&lang=js"
export * from "./InterviewCreate.vue?vue&type=script&lang=js"
import style0 from "./InterviewCreate.vue?vue&type=style&index=0&id=99fc565a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports